import * as z from 'zod'

export const createAccountSchema = z
  .object({
    email: z.email(),
    password: z.string().min(8),
    password_confirmation: z.string(),
    name: z.string(),
    birthdate: z.string(),
    username: z.string(),
  })
  .refine(
    ({ password, password_confirmation }) => password === password_confirmation,
    { path: ['password_confirmation'] },
  )

export type CreateAccountDto = z.infer<typeof createAccountSchema>
